export const colTitles = ["Total Days", "End Date", "Start Date", "Treatment"];
